<template>
	<div class="stock">
		<div class="wx_box">
			<div class="wx_main">
				<div class="top">
					<div class="wx_title">
						<span>库存管理</span>
					</div>
				</div>
				<div class="search_top">
					<div class="search_box">
						<el-select clearable v-model="tabPage.type" placeholder="农资种类" size="medium" @change="changeSearchType">
							<el-option v-for="item in typeList" :key="'search_type'+item.id" :label="item.name" :value="item.id">
							</el-option>
							<el-option  key="search_type17" label="肥料" value="17">
							</el-option>
						</el-select>
						<el-select clearable v-model="tabPage.materials_cate_id" placeholder="类别" size="medium" @change="changeCategory" v-if="is_search===false && is_select==1">
							<el-option v-for="item in category_list" :key="'search_cate'+item.id" :label="item.name" :value="item.id">
							</el-option>
						</el-select>
						<el-select clearable v-model="tabPage.materials_cate_id" placeholder="类别" size="medium" @change="changeCategory" v-if="is_search===true && is_select==1">
							<el-option v-for="item in materials_category_list" :key="'search_sohu_cate17'+item.id" :label="item.name" :value="item.id">
							</el-option>
						</el-select>
						<el-select clearable v-model="tabPage.materials_ingred_id" placeholder="成分" size="medium"  v-if="is_search===true && is_select==1">
							<el-option v-for="item in materials_ingred_list" :key="'search_ingred'+item.id" :label="item.name" :value="item.id">
							</el-option>
						</el-select>
						<el-select clearable v-model="tabPage.obj" placeholder="适用对象" size="medium">
							<el-option v-for="(item,index) in objList" :key="'search_obj1'+item.dict_id+index" :label="item.dict_name" :value="item.dict_id">
							</el-option>
						</el-select>
					<!-- 	<el-select clearable v-model="tabPage.insect_pest_id" placeholder="适用病虫害" size="medium">
							<el-option v-for="item in insectPestList" :key="'search_pest2'+item.id" :label="item.insect_pest_name"
								:value="item.id">
							</el-option>
						</el-select> -->
						<el-select clearable v-model="tabPage.state" placeholder="库存状态" size="medium">
							<el-option v-for="item in stateList" :key="'search_stock'+item.id" :label="item.value" :value="item.id">
							</el-option>
						</el-select>
						<el-input placeholder="请输入内容" v-model="tabPage.keyword" class="input-with-select" size="medium">
							<div class="searchIcon" slot="prepend"><img src="../../assets/images/search.png" alt="">
							</div>
						</el-input>
						<el-button size="medium" type="primary" @click="search()" style="margin: 15px;">搜索</el-button>
					</div>
					<div class="btns" v-if="user_position_code<300">
						<el-button class="addBtn" @click="soilShow=true">新增肥料</el-button>
						<el-button class="addBtn" @click="materialShow=true">新增农资</el-button>
						<el-button class="addBtn" @click="addShow=true">加持已有农资</el-button>
						<el-button class="addBtn" @click="reduceShow=true">减持已有农资</el-button>
					</div>
				</div>
				<table class="my_table">
					<thead>
						<tr>
							<th style="min-width:200px">名称</th>
							<th width="90">农资种类</th>
							<th width="80">类别</th>
							<th style="min-width:100px">成分</th>
							<th width="90">形状类型</th>
							<th style="min-width:120px">适用对象</th>
							<!-- <th>适用病虫害</th> -->
							<th width="120">稀释比例</th>
							<th width="150">每亩用量</th>
							<th width="150">剩余量</th>
							<th width="90">图片</th>
							<th width="90">状态</th>
							<th width="200">操作</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(item,index) in tableData">
							<td>{{item.name}}</td>
							<td>{{item.type.name}}</td>
							<td>{{item.category_name}}</td>
							<td>{{item.ingred_name}}</td>
							<td>{{item.sex.name}}</td>
							<!-- <td><span v-for="(ob,inx) in item.obj" :key="'list_ob'+inx">{{ob.dict_name}} &nbsp;</span></td> -->
							<td><span v-for="(pest,inx) in item.pest" :key="'list_pest'+inx">{{pest.insect_pest_name}} &nbsp;</span></td>
							<td>{{item.min}}-{{item.max}}</td>
							<td>{{item.dosage}}{{item.dosage_units_name}}</td>
							<td>{{item.stock_number}}{{item.dosage_units_name}}</td>
							<td>
								<img :src="img" alt="" v-for="(img,key) in item.images" @click="jump(item.images)" :key="'list_img'+key">
							</td>
							<td v-if="user_position_code<300">
								<el-button class="edit_btn" type="primary" plain size="small" v-if="item.is_lock==2" @click="lock(item.id,1)">锁定</el-button>
								<el-button class="detail_btn" type="primary" plain size="small" v-else @click="lock(item.id,2)">解锁</el-button>
							</td>
							<td v-else>
								<el-button class="edit_btn" type="primary" plain size="small" v-if="item.is_lock==2" >未锁定</el-button>
								<el-button class="detail_btn" type="primary" plain size="small" v-else>已锁定</el-button>
							</td>
							<td v-if="user_position_code<300">
								<el-button class="edit_btn" type="primary" plain size="small"
									@click="editSoil(item)" v-if="item.type.id==17">编辑</el-button>
								<el-button class="edit_btn" type="primary" plain size="small"  @click="editMaterials(item)"  v-else>编辑</el-button>
								<el-button class="detail_btn" type="success" plain size="small"
									@click="$router.push('/park/stock/detail/'+farm_id+'/'+item.id)">明细查看</el-button>
							</td>
							<td v-else>
								<el-button class="detail_btn" type="success" plain size="small"
									@click="$router.push('/park/stock/detail/'+farm_id+'/'+item.id)">明细查看</el-button>
							</td>
						</tr>
					</tbody>
				</table>
				<div class="pagination">
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
						:current-page="tabPage.currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="tabPage.pagesize"
						layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
				</div>
			</div>
		</div>

		<!--编辑肥料-->
		<WxMessageBox :show="editSoilShow" @save="editSoilSave" @canse="editSoilCanse">
			<div slot="content">
				<el-form :model="editSoilForm" :rules="editSoilRules" ref="editSoilForm" label-width="0px">
					<div class="copyDetail marTop44">

						<div class="form_item">
							<span class="lable">肥料:</span>
							<div class="input">
								<el-form-item label="" prop="material_id">
									<el-select v-model="editSoilForm.material_id" placeholder="请选择" size="mini">
										<el-option v-for="item in material_list" :key="item.id" :label="item.name"
											:value="item.id">
										</el-option>
									</el-select>
								</el-form-item>
							</div>
						</div>

					</div>
				</el-form>
			</div>
		</WxMessageBox>
		<!--新增农资-->
		<WxMessageBox :show="materialShow" width="770px" @save="materialSave" @canse="materialCanse">
		            <div slot="content">
		                <el-form :model="materialForm" :rules="materialRules" ref="materialForm" label-width="0px">
		                    <div class="copyDetail marTop44 flexMessageBox">
		                        <div class="form_item">
		                            <span class="lable">农资类型:</span>
		                            <div class="input">
		                                <el-form-item label="" prop="type">
		                                    <el-select v-model="materialForm.type" placeholder="请选择" size="mini">
		                                        <el-option v-for="item in typeList" :key="'type'+item.id" :label="item.name"
		                                                   :value="item.id">
		                                        </el-option>
											
												</el-option>
		                                    </el-select>
		                                </el-form-item>
		                            </div>
		                        </div>
		                        <div class="form_item">
		                            <span class="lable">农资名称:</span>
		                            <div class="input">
		                                <el-form-item label="" prop="name">
		                                    <el-input v-model="materialForm.name" size="mini" placeholder="请输入农资名称"></el-input>
		                                </el-form-item>
		                            </div>
		                        </div>
								<div class="form_item">
								    <span class="lable">农资类别:</span>
								    <div class="input">
								        <el-form-item label="" prop="materials_cate_id">
								            <el-select v-model="materialForm.materials_cate_id" placeholder="请选择" size="mini" @change="changeCategory">
								                <el-option v-for="item in materials_category_list" :key="'cate'+item.id" :label="item.name"
								                           :value="item.id" v-if="item.id!==17">
								                </el-option>
								            </el-select>
								        </el-form-item>
								    </div>
								</div>
								<div class="form_item">
								    <span class="lable">农资成分:</span>
								    <div class="input">
								        <el-form-item label="" prop="materials_ingred_id">
								            <el-select v-model="materialForm.materials_ingred_id" placeholder="请选择" size="mini">
								                <el-option v-for="item in materials_ingred_list" :key="'ingred'+item.id" :label="item.name"
								                           :value="item.id" v-if="item.id!==17">
								                </el-option>
								            </el-select>
								        </el-form-item>
								    </div>
								</div>
		                        <div class="form_item">
		                            <span class="lable">性状类型:</span>
		                            <div class="input">
		                                <el-form-item label="" prop="sex_type">
		                                    <el-select v-model="materialForm.sex_type" placeholder="请选择" size="small">
		                                        <el-option v-for="item in sexList" :key="'sex_type'+item.id" :label="item.name"
		                                                   :value="item.id">
		                                        </el-option>
		                                    </el-select>
		                                </el-form-item>
		                            </div>
		                        </div>
		                        <div class="form_item">
		                            <span class="lable">适用对象:</span>
		                            <div class="input input_obj">
		                                <el-form-item label="" prop="objs">
		                                    <el-checkbox-group v-model="materialForm.objs">
		                                        <el-checkbox  v-for="(item,index) in objList" :label="item.dict_id" :key="'objssss'+index">{{item.dict_name}}</el-checkbox>
		                                    </el-checkbox-group>
		                                </el-form-item>
		                            </div>
		                        </div>
		                        <div class="form_item">
		                            <span class="lable">病虫害(可以多选):</span>
		                            <div class="input">
		                                <el-form-item label="" prop="pests">
		                                    <el-select v-model="materialForm.pests" placeholder="请选择" size="small" multiple clearable>
		                                        <el-option
												          :key="'pest'+item.id" 
														  :label="item.insect_pest_name"
		                                                   :value="item.id"  v-for="item in insectPestList">
		                                        </el-option>
		                                    </el-select>
		                                </el-form-item>
		                            </div>
		                        </div>
		
		                        <div class="form_item">
		                            <span class="lable">稀释比例:</span>
		                            <div class="input billie" style="">
		                                <el-form-item label="" prop="min">
		                                    <el-input class="w96" v-model="materialForm.min" size="small" placeholder="最小值"></el-input>
		                                </el-form-item>-
		                                <el-form-item label="" prop="max">
		                                    <el-input class="w96" v-model="materialForm.max" size="small" placeholder="最大值"></el-input>
		                                </el-form-item>
		                            </div>
		                        </div>
		                        <div class="form_item">
		                            <span class="lable">每亩用量:</span>
		                            <div class="input">
		                                <el-form-item label="" prop="dosage">
		                                    <el-input v-model="materialForm.dosage" size="small" placeholder="每亩用量" type="number"></el-input>
		                                </el-form-item>
		                            </div>
		                        </div>
		                        <div class="form_item">
		                            <span class="lable">用量单位:</span>
		                            <div class="input">
		                                <el-form-item label="" prop="dosage_units_name">
		                                    <el-select v-model="materialForm.dosage_units_name" placeholder="请选择" size="small" >
		                                        <el-option v-for="item in unit_list" :key="'dosage_units_name'+item.id" :label="item.name"
		                                                   :value="item.name">
		                                        </el-option>
		                                    </el-select>
		                                </el-form-item>
		                            </div>
		                        </div>
		                        <!-- <div class="form_item"  v-if="editMaterial==false">
		                            <span class="lable">采购总价:</span>
		                            <div class="input">
		                                <el-form-item label="" prop="total_price">
		                                    <el-input v-model="materialForm.total_price" size="small" placeholder="每亩用量" type="number"></el-input>
		                                </el-form-item>
		                            </div>
		                        </div> -->
								<div class="form_item" v-if="editMaterial==false">
								    <span class="lable">采购总价:</span>
								    <div class="input">
								        <el-form-item label="" prop="total_price">
								            <el-input v-model="materialForm.total_price" size="small" placeholder="采购总价" type="number"></el-input>
								        </el-form-item>
								    </div>
								    <span class="subLabel" style="color: #fff;line-height: 35px;padding-left: 10px;">元</span>
								</div>
		                        
		
		                        <div class="form_item" v-if="editMaterial==false">
		                            <span class="lable">采购总量:</span>
		                            <div class="input">
		                                <el-form-item label="" prop="stock_number">
		                                    <el-input v-model="materialForm.stock_number" size="small" placeholder="采购用量" type="number"></el-input>
		                                </el-form-item>
		                            </div>
		                        </div>
		
								<div class="form_item">
								    <span class="lable">采购单位:</span>
								    <div class="input">
								        <el-form-item label="" prop="units_name">
								            <el-select v-model="materialForm.units_name" placeholder="请选择" size="small" >
								                <el-option v-for="item in unit_list" :key="'units_name'+item.id" :label="item.name"
								                           :value="item.name">
								                </el-option>
								            </el-select>
								        </el-form-item>
								    </div>
								</div>
		                        <div class="form_item img_item">
		                            <span class="lable">包装图片:</span>
		                            <div class="input">
		                                <el-form-item label="" prop="images">
		                                    <el-upload
		                                           :action="uploadAction"
												   :headers="myHeaders"
												    :on-success="handleSuccess" 
													:before-upload="beforeUpload"
													:on-preview="handlePreview"
													 :show-file-list="true" 
													 :file-list="fileList"
		                                            list-type="picture-card"
		                                    >
		                                        <div class="crop"></div>
		                                    </el-upload>
		                                </el-form-item>
		                            </div>
		                        </div>
		                    </div>
		
		                </el-form>
						<el-dialog :visible.sync="dialogVisibles" :modal="false">
						  <img width="100%" :src="dialogVisibleimage" alt="">
						</el-dialog>
		            </div>
		        </WxMessageBox>
		<!--新增肥料-->
		<WxMessageBox :show="soilShow" @save="soilSave" @canse="soilCanse">
			<div slot="content">
				<el-form :model="soilForm" :rules="soilRules" ref="soilForm" label-width="0px">
					<div class="copyDetail marTop44">
		<div class="form_item">
						    <span class="lable">肥料类别:</span>
						    <div class="input">
						        <el-form-item label="" prop="materials_cate_id">
						            <el-select v-model="soilForm.materials_cate_id" placeholder="请选择" size="mini"  @change="changeMaterialsCategory">
						                <el-option v-for="item in category_list" :key="'cate'+item.id" :label="item.name"
						                           :value="item.id">
						                </el-option>
						            </el-select>
						        </el-form-item>
						    </div>
						</div>
						<div class="form_item">
							<span class="lable">肥料:</span>
							<div class="input">
								<el-form-item label="" prop="material_id">
									<el-select v-model="soilForm.material_id" placeholder="请选择" size="mini" @change="changeSoil">
										<el-option v-for="item in material_list" :key="item.id" :label="item.name"
											:value="item.id">
										</el-option>
									</el-select>
								</el-form-item>
							</div>
						</div>
				
						<div class="form_item">

							<span class="lable">总价:</span>
							<div class="input">
								<el-form-item label="" prop="total_price">
									<el-input class="w106" style="width: 175px;" v-model="soilForm.total_price" size="mini" placeholder="请填数字"
										type="number"></el-input>

								</el-form-item>
							</div>
							<span class="subLabel" style="color: #fff;padding-left: 10px;">元</span>
						</div>
						<!-- <div class="form_item" style="display: none;">
							<span class="lable">单位:</span>
							<div class="input">
								<el-form-item label="" prop="units_name">
									<el-select v-model="soilForm.units_name" placeholder="请选择" size="mini">
										<el-option v-for="item in unit_list" :key="item.id" :label="item.name"
											:value="item.name">
										</el-option>
									</el-select>
								</el-form-item>
							</div>
						</div> -->
						<div class="form_item">
							<span class="lable">采购数量:</span>
							<div class="input">
								<el-form-item label="" prop="stock_number">
									<el-input class="w106" style="width: 200px;" v-model="soilForm.stock_number" size="mini"
										placeholder="请填数字" type="number"></el-input>

								</el-form-item>
							</div>

						</div>
                     <div class="form_item">
						
							<span class="lable">单位:</span>
							<div class="input">
								     <span style="color: white;"> {{units_name}}</span>
							</div>
						</div>
					</div>
				</el-form>
			</div>
		</WxMessageBox>
		
		<!--减持持肥料-->
		<WxMessageBox :show="reduceShow" @save="reduceSave" @canse="reduceCanse">
			<div slot="content">
				<el-form :model="reduceForm" :rules="reduceRules" ref="reduceForm" label-width="0px">
					<div class="copyDetail marTop44">
		
						<div class="form_item">
											<span class="lable">农资类型:</span>
											<div class="input">
												<el-form-item label="" prop="type">
													<el-select v-model="reduceForm.type" placeholder="请选择" size="mini" @change="changeType">
														<el-option v-for="item in typeList" :key="'add_type_'+item.id" :label="item.name"
															:value="item.id">
														</el-option>
														<el-option  key="type17" label="化肥"
														           value="17"></el-option>
													</el-select>
												</el-form-item>
											</div>
										</div>
						<div class="form_item">
							<span class="lable">农资名称:</span>
							<div class="input">
								<el-form-item label="" prop="farm_materials_id">
									<el-select v-model="reduceForm.farm_materials_id" placeholder="请选择" size="mini" @change="displayUnit">
										<el-option v-for="item in materials_list" :key="'materials_'+item.id" :label="item.name"
											:value="item.id">
										</el-option>
									</el-select>
								</el-form-item>
							</div>
						</div>
						<div class="form_item">
							<span class="lable">原因:</span>
							<div class="input">
								<el-form-item label="" prop="remark">
									 <el-radio-group v-model="reduceForm.remark">
									    <el-radio label="丢弃">丢弃</el-radio>
									    <el-radio label="过期">过期</el-radio>
									    <el-radio label="遗失">遗失</el-radio>
									  </el-radio-group>
								</el-form-item>
							</div>
						</div>
		<div class="form_item">
			<span class="lable">减量:</span>
			<div class="input">
				<el-form-item label="" prop="number">
					<el-input class="w106" v-model="reduceForm.number" size="mini"
						placeholder="请填数字" type="number" style="width: 200px;"></el-input><span style="color: white;">{{unit_name}}</span>
				</el-form-item>
			</div>
		</div>
					</div>
				</el-form>
			</div>
		</WxMessageBox>	
		<!--加持肥料-->
		<WxMessageBox :show="addShow" @save="addSave" @canse="addCanse">
			<div slot="content">
				<el-form :model="addForm" :rules="addRules" ref="addForm" label-width="0px">
					<div class="copyDetail  marTop44 flexMessageBox">
		
						<div class="form_item">
							<span class="lable">农资种类:</span>
							<div class="input">
								<el-form-item label="" prop="type">
									<el-select v-model="addForm.type" placeholder="请选择" size="mini" @change="changeType">
										<el-option v-for="item in typeList" :key="'add_type_'+item.id" :label="item.name"
											:value="item.id">
										</el-option>
										<el-option  key="type17" label="化肥"
										           value="17"></el-option>
									</el-select>
								</el-form-item>
							</div>
						</div>
		<div class="form_item">
			<span class="lable">农资名称:</span>
			<div class="input">
				<el-form-item label="" prop="farm_materials_id">
					<el-select v-model="addForm.farm_materials_id" placeholder="请选择" size="mini" @change="displayUnit">
						<el-option v-for="item in materials_list" :key="'materials_'+item.id" :label="item.name"
							:value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
			</div>
		</div>
		<div class="form_item">
			<span class="lable">总量:</span>
			<div class="input">
				<el-form-item label="" prop="number">
					<el-input v-model="addForm.number" size="mini"
						placeholder="请填数字" type="number"></el-input><span style="color: white;">{{unit_name}}</span>
				</el-form-item>
			</div>
		</div>
		<!-- <div class="form_item">
			<span class="lable">总价:</span>
			<div class="input">
				<el-form-item label="" prop="total_price">
					<el-input class="w106" v-model="addForm.total_price" size="mini"
						placeholder="请填数字" type="number"></el-input>
				</el-form-item>
			</div>
		</div> -->
		<div class="form_item">
		    <span class="lable">总价:</span>
		    <div class="input">
		    	<el-form-item label="" prop="total_price">
		    		<el-input style="width: 170px;" v-model="addForm.total_price" size="mini"
		    			placeholder="请填数字" type="number"></el-input>
		    	</el-form-item>
		    </div>
		    <span class="subLabel" style="color: #fff;padding-left: 10px;line-height: 35px;">元</span>
		</div>
		<div class="form_item img_item" v-if="addImagesShow==true">
		                            <span class="lable">包装图片:</span>
		                            <div class="input">
		                                <el-form-item label="" prop="images">
		                                    <el-upload
		                                           :action="uploadAction"
												   :headers="myHeaders"
												    :on-success="handleAddSuccess" 
													:before-upload="beforeUpload"
													 :show-file-list="true" 
													 :file-list="addFileList"
		                                            list-type="picture-card"
		                                    >
		                                        <div class="crop"></div>
		                                    </el-upload>
		                                    
		                                </el-form-item>
		                            </div>
		                        </div>
					</div>
				</el-form>
			</div>
		</WxMessageBox>
<!--		点击图片显示-->
		<el-dialog title="图片" :visible.sync="dialogVisible" width="40%" class="dialogVisibleImg">
			<el-carousel height="500px" :autoplay="false">
				<el-carousel-item v-for="(item,key) in imgList" :key="key">
					<img :src="item" alt="" :key="'list_img'+key">
				</el-carousel-item>
			</el-carousel>
		</el-dialog>
		<el-dialog
		  title="提示"
		  :visible.sync="lockDialogVisible"
		  width="30%"
		  center>
		  <span>你确认要进行此操作嘛?</span>
		  <span slot="footer" class="dialog-footer">
		    <el-button @click="lockDialogVisible = false">取 消</el-button>
		    <el-button type="primary" @click="confirm_lock()">确 定</el-button>
		  </span>
		</el-dialog>
	</div>
</template>
<script>
	import {
		getFarmMaterials,
		saveFarmSoil,
		editFarmSoil,
		saveFarmMaterials,
		getMaterialList,
		addMaterialStock,
		changeSoil,
		stocklock,
		changeMaterialCategory,
		changeMaterialsCategory,
		reduceMaterialStock
	} from '@/api/api'
	import {
		getFarmInfo
	} from '@/api/api'
	import axios from 'axios';
	import WxMessageBox from '@/components/MessageBox';
	export default {
		name: "Stock",
		data() {
			return {
				uploadAction: axios.defaults.baseURL + "/upload/image",
				myHeaders: {
					authorization: "Bear " + localStorage.getItem("token")
				},
				user_position_code:'',
				total:0,
				units_name:"请选择肥料和肥料分类",
				editMaterial:false,
				lockDialogVisible:false,
				addShow:false,
				reduceShow:false,
				soilShow: false,
				editSoilShow: false,
				addImagesShow:true,
				materialShow: false,
				dialogVisible:false,
				dialogVisibles:false,
				dialogVisibleimage:'',
				is_search:false,
				is_select:0,
				imgList:[],
				fileList:[],
				sexList: [],
				typeList: [],
				objList: [],
				insectPestList: [],
				materials_category_list:[],
				materials_ingred_list:[],
				category_list:[],
				stateList: [{
					id: 1,
					value: "有库存"
				}, {
					id: 2,
					value: "无库存"
				}],

				tableData: [],
				tabPage: {
					insect_pest_id: '',
					materials_ingred_id:'',
					materials_cate_id:'',
					type: '',
					obj: '',
					state: '',
					keyword: '',
					currentPage: 1, // 初始页
					pagesize: 10, // 每页的数据
				},
				//新增肥料
				material_list: [],
				unit_list: [],
				soilForm: {
					material_id: '',
					materials_cate_id:'',
					total_price: '',
					units_name: '',
					stock_number: '',
				},
				soilRules: {
					total_price: [{required: true,message: '请输入总价',trigger: 'blur'}],
					materials_cate_id: [{required: true,message: '请选择化肥类别',trigger: 'change'}],
					material_id: [{required: true,message: '请选择对应肥料',trigger: 'change'}],
					stock_number: [{required: true,message: '请输入采购总量',trigger: 'blur'}],
					units_name: [{required: true,message: '请选择单位',trigger: 'change'}],
				},
				//编辑
				editSoilForm: {
					id: '',
					material_id: '',
				},
				editSoilRules: {
					material_id: [{
						required: true,
						message: '请选择对应肥料',
						trigger: 'change'
					}],
				},
				//农资

				materialForm:  {
					id: '',
					type:'',
					name:'',
					materials_cate_id:'',
					materials_ingred_id:'',
					sex_type:'',
					objs:[],
					pests:[],
					min:'',
					max:'',
					dosage:'',
					dosage_units_name:'',
					total_price:'',
					units_name:'',
					stock_number:'',
					images:[],
				},
				materialRules: {
					type: [{required: true,message: '请选择农资对应分类',trigger: 'change'}],
					name: [{required: true,message: '请选择农资名称',trigger: 'blur'}],
					sex_type: [{required: true,message: '请选择农资性状类型',trigger: 'change'}],
					materials_cate_id: [{required: true,message: '请选择农资类别',trigger: 'change'}],
					materials_ingred_id: [{required: true,message: '请选择农资成分',trigger: 'change'}],
					objs: [{required: true,message: '请选择农资适用对象',trigger: 'change'}],
					pests: [{required: true,message: '请选择农资对应病虫害',trigger: 'change'}],
					min: [{required: true,message: '请输入释放比率最小值',trigger: 'blur'}],
					max: [{required: true,message: '请输入释放比率最大值',trigger: 'blur'}],
					dosage: [{required: true,message: '请输入农资用量',trigger: 'blur'}],
					dosage_units_name: [{required: true,message: '请选择农资用量单位',trigger: 'change'}],
					total_price: [{required: true,message: '请输入农资采购总价',trigger: 'blur'}],
					units_name: [{required: true,message: '请选择农资采购单位',trigger: 'change'}],
					stock_number: [{required: true,message: '请输入农资采购数量',trigger: 'blur'}],
					images: [{required: true,message: '请输入农资包装图片',trigger: 'blur'}],
					

				},
				//加持
				materials_list: [],
				addFileList:[],
				unit_name:'',
				addForm:{
					 type:'',
					 farm_materials_id:'',
					 number:'',
					 total_price:'',
					 images:[],
					 
				},
				addRules:{
					type: [{required: true,message: '请选择农资对应分类',trigger: 'change'}],
					farm_materials_id: [{required: true,message: '请选择农资',trigger: 'change'}],
					number: [{required: true,message: '请输入农资采购数量',trigger: 'blur'}],
					total_price: [{required: true,message: '请输入农资采购总价',trigger: 'blur'}],
					//images: [{required: true,message: '请输入农资包装图片',trigger: 'blur'}],
				},
				
				reduceForm:{
					 type:'',
					 farm_materials_id:'',
					 number:'',
					 remark:'',
					 
				},
				reduceRules:{
					type: [{required: true,message: '请选择农资对应分类',trigger: 'change'}],
					farm_materials_id: [{required: true,message: '请选择农资',trigger: 'change'}],
					number: [{required: true,message: '请输入农资采购数量',trigger: 'blur'}],
					remark: [{required: true,message: '请选择原因',trigger: 'blur'}],

				},

			}
		},
		mounted() {
			this.farm_id = this.$route.params.id
			getFarmInfo(this.$route.params.id).then(resp => {
			
			 this.user_position_code=resp.user_position_code
				if(resp.farm.is_check==1){
					this.get_farm_materials()
				}else{
					this.$message.error("请先完善农事管理板块相关申请工作，才能开通此板块！")
					this.$router.push("/park/detail/"+this.$route.params.id)
				}
				})
			
		},
		methods: {
			lock(id,is_lock){
				  this.lockDialogVisible=true,
				  this.stock_id=id
				  this.is_lock=is_lock
			},
			confirm_lock(){
				stocklock(this.stock_id,this.is_lock).then(resp=>{
					this.lockDialogVisible=false
					this.get_farm_materials()
				})
			},
			changeMaterialsCategory(val){
				changeMaterialsCategory(val).then(resp=>{
					this.material_list=resp
				})
			},
			changeCategory(val){
				if(val==''){
					this.materials_ingred_list=[]
				}else{
				changeMaterialCategory(val).then(res=>{
					this.materials_ingred_list=res
				})
				}
			},
			changeSoil(val){
				changeSoil(val).then(res=>{
					console.log(res)
					//this.soilForm["units_name"]=res
					this.units_name=res
				})
			},
			get_farm_materials() {
				getFarmMaterials(this.farm_id, this.tabPage).then(resp => {
					this.tableData = resp.data
					this.total=resp.total
					//this.material_list = resp.material_list
					this.insectPestList = resp.pest_list
					this.typeList = resp.type_list
					this.sexList = resp.sex_list
					this.objList = resp.obj_list
					this.materials_category_list=resp.materials_category_list, //
					this.category_list=resp.category_list //肥料分类
					this.unit_list = resp.unit_list
				})
			},

			// 分页
			handleSizeChange: function(size) {
				this.tabPage.pagesize = size;
				this.get_farm_materials()
			},
			handleCurrentChange: function(currentPage) {
				this.tabPage.currentPage = currentPage;
				this.get_farm_materials()
			},
			changeType(type){
				this.addForm["farm_materials_id"]=''
				this.reduceForm["farm_materials_id"]=''
				 getMaterialList(this.farm_id,type).then(resp=>{
					 this.materials_list=resp;
					 if(type==17){
						this.addImagesShow=false;
					 }else{
						 this.addImagesShow=true;
					 }
				 })
			},
			displayUnit(val){
				this.materials_list.forEach(item => {
				        if(val===item.id){
							this.unit_name=item.units_name
						}
					
				}); 
			},
			addSave() {
				console.log(this.addForm);
				this.$refs["addForm"].validate((valid) => {
					if (valid) {			
						addMaterialStock(this.farm_id,this.addForm).then(resp => {
				
							this.$message.success("加持成功");
							this.get_farm_materials()
							this.materials_list=[],
							this.addShow = false
				            this.addForm=this.$options.data().addForm
				            this.addFileList=[]
							this.unit_name=''
							this.clearAddForm()
						}).catch(error => console.log(error))
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			addCanse() {
				this.unit_name=''
				this.materials_list=[],
				this.addShow = false
				this.clearAddForm()
			},
			
			clearAddForm(){
				this.addForm={
					 type:'',
					 farm_materials_id:'',
					 number:'',
					 total_price:'',
					 images:[],
					 
				}
			},
			reduceSave() {
				this.$refs["reduceForm"].validate((valid) => {
					if (valid) {			
						reduceMaterialStock(this.farm_id,this.reduceForm).then(resp => {
				
							this.$message.success("加持成功");
							this.get_farm_materials()
							this.materials_list=[],
							this.reduceShow = false
				            this.reduceForm=this.$options.data().reduceForm
				           this.clearReduceForm()
							this.unit_name=''
						}).catch(error => console.log(error))
					} else {
						console.log('error submit!!');
						return false;
					}
				});
				
			},
			reduceCanse() {
				this.unit_name=''
				this.materials_list=[],
				this.reduceShow = false
				this.clearReduceForm()
			},
			clearReduceForm(){
				this.reduceForm={
					 type:'',
					 farm_materials_id:'',
					 number:'',
					 remark:'',
					 
				}
			},
			soilSave() {
				this.$refs["soilForm"].validate((valid) => {
					if (valid) {

						saveFarmSoil(this.farm_id, this.soilForm).then(resp => {

                            this.clearSoilForm()
							this.$message.success("添加成功");
							this.get_farm_materials()
							this.soilShow = false

						}).catch(error => console.log(error))
					} else {
						console.log('error submit!!');
						return false;
					}
				});

			},
			soilCanse() {
				this.soilShow = false
				this.clearSoilForm()
			},
			
			clearSoilForm(){
				this.soilForm={
					material_id: '',
					materials_cate_id:'',
					total_price: '',
					units_name: '',
					stock_number: '',
				}
			},
			saveSave() {
				this.saveShow = false
			},
			saveCanse() {
				this.saveShow = false
			},
			//编辑肥料
			editSoilSave() {
				this.$refs["editSoilForm"].validate((valid) => {
					if (valid) {

						editFarmSoil(this.farm_id, this.editSoilForm).then(resp => {

							this.$message.success("编辑成功");
							this.get_farm_materials()
							this.editSoilShow = false

						}).catch(error => console.log(error))
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			editSoilCanse() {
				this.editSoilShow = false
			},
			editSoil(item) {
				this.editSoilForm["id"] = item.id
				this.editSoilShow = true
			},
			editMaterials(item) {
				console.log(item)
				let objs=[]
				item.obj.forEach(element => {
				   
					objs.push(element.dict_id)
				}); 
				item.objs=objs
				let pests=[]
				item.pest.forEach(element => {
					pests.push(element.insect_pest_id)
				}); 
				//item.pests=[3,4]				//item.remove('obj');
				//this.materialForm = item
				//this.materialForm=item
			///	this.materialForm=item
				this.materialForm["id"]=item.id
				this.materialForm["name"]=item.name
				this.materialForm["materials_cate_id"]=item.materials_cate_id
				this.changeCategory(item.materials_cate_id)
				this.materialForm["materials_ingred_id"]=item.materials_ingred_id
				this.materialForm["type"]=item.type
				this.materialForm["sex_type"]=item.sex_type
				this.materialForm["objs"]=item.objs
				this.materialForm["obj"]=item.obj
				this.materialForm["min"]=item.min
				this.materialForm["max"]=item.max
				this.materialForm["dosage"]=item.dosage
				this.materialForm["dosage_units_name"]=item.dosage_units_name
				this.materialForm["total_price"]=item.total_price
				this.materialForm["units_name"]=item.units_name
				this.materialForm["stock_number"]=item.stock_number
				this.materialForm["images"]=item.images
			this.materialForm["pest"]=pests
				this.materialForm["pests"]=pests
				console.log(this.materialForm)
				this.editMaterial=true
				this.materialShow=true
				item.images.forEach(element => {  
				   
					this.fileList.push({url:element})
				});  
				
			},
			materialSave() {
				this.$refs["materialForm"].validate((valid) => {
					if (valid) {
						saveFarmMaterials(this.farm_id, this.materialForm).then(resp => {				
							this.$message.success("修改成功");
							this.get_farm_materials()
							this.materialShow = false
							this.materialForm=this.$options.data().materialForm
							this.fileList=[]
				
						}).catch(error => console.log(error))
					} else {
						console.log('error submit!!');
						return false;
					}
				});
				
			},
			materialCanse() {
				this.materialShow = false
				this.materialForm=this.$options.data().materialForm
				this.fileList=[]
			},
			jump(imgs) {
				this.imgList = imgs
				this.dialogVisible = true
			},
			
			changeSearchType(val){
				this.is_select=1;
				if(val==17){
					this.is_search=false
				}else{
					this.is_search=true
				}
			},
			search() {
				this.get_farm_materials()
			},
			handleSuccess(res, file) {
				//this.imgUrl = URL.createObjectURL(file.raw);
				this.fileList.push({url:res.data})
				
				this.materialForm["images"].push(res.data)
				console.log(this.materialForm["images"])
			},
			handlePreview(file) {
				this.dialogVisibles = true
				this.dialogVisibleimage = file.url
			    },
			handleAddSuccess(res, file) {
				//this.imgUrl = URL.createObjectURL(file.raw);
				this.addFileList.push({url:res.data})
				this.addForm["images"].push(res.data)
			},
			beforeUpload(file) {
				const isJPG = file.type === 'image/jpeg';
				 const isPng = file.type === 'image/png';
								 const isLt2M = file.size / 1024 / 1024 < 2;
								 if (!isLt2M) {
								     this.$message.error('上传图片大小不能超过 2MB!');
								 }
				 if (!isJPG && !isPng) {
									
				     this.$message.error('上传图片只能是 JPG或PNG 格式!');
				    return false
				}else{
				  	return true
				}
			},
		},
		components: {
			WxMessageBox
		}
	}
</script>

<style lang="less">
	.stock {
		.wx_box {
			.wx_main {
				background: radial-gradient(rgba(19, 62, 173, 0.74), rgba(5, 18, 32, 0.47));
				background-size: cover;
				padding: 11px 35px 50px 24px;

				.top {
					overflow: hidden;
				}

				.search_top {
					display: flex;
					justify-content: space-between;
					align-items: center;
					margin-top: 30px;

					.el-select {
						width: 130px;

						&+.el-select {
							margin-left: 14px;
						}
					}

					.input-with-select {
						width: 200px;
						margin-left: 14px;

						.el-input-group__append,
						.el-input-group__prepend {
							background: rgba(45, 153, 255, 0.3);
						}
					}

					.btns {
						.addBtn {
							border: 1px solid #2D99FF;
							background-color: transparent;
							font-size: 18px;
							font-weight: 400;
							color: #2D99FF;
							padding: 7px 18px;
							border-radius: 0;
						}
					}
				}

				.my_table {
					margin-top: 25px;

					tr {
						td {
							img {
								width: 66px;
								height: 36px;
								cursor: pointer;
								&+img{
									margin-left: 5px;
								}
							}
						}
					}
				}
			}
		}
	}
	.dialogVisibleImg{
		.el-dialog__body{
			.el-carousel__item{
				text-align: center;
			}
			img{
				display: inline-block;
				max-width: 100%;
				height: 100%;
			}
		}
	}
</style>
